<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
        (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in">{{modalTitle}}</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <div class="col-xs-12">
                <app-override-candidate-suspension
                    [candidateId]="candidateId"
                    [candidateName]="candidateName"
                    [releaseDate]="releaseDate"
                    [suspendedMonths]="suspendedMonths"
                    [allowOverride]="allowOverride"
                    [recruiterDetails]="recruiterDetails"
                    [type]="type"
                    [releasedJobDetails]="releasedJobDetails"
                    (saveCallback)="saveCallback()"
                    (cancelCallback)="closeModal()">
                </app-override-candidate-suspension>
            </div>
        </div>
    </div>
</div>
